import { CompanyVoteProposalNameSearchFilter } from '../../models/companyVoteProposalNameSearchFilter';

export interface ICompanyVoteProposalNameListState {
  searchFilter: CompanyVoteProposalNameSearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

// `year` is intentionally omitted: the active business year is unknown at module-load time
// (the JS bundle parses before provideAppInitializer runs). The list component fills it in from
// the live ActiveYearService value on first load, then the store carries the user's selection.
export const initialCompanyVoteProposalNameListState: ICompanyVoteProposalNameListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'fullName',
  ascending: true
};
